import React, { PureComponent } from 'react';
// import PropTypes from 'prop-types';
import './PublicFooter.scss';
import Wrapper from 'components/Wrapper';
import Logo from 'assets/images/logo_footer.png';
import { Twitter, FaceBook, LinkedIn, Youtube } from 'components/SvgIcons';
import Sponser1 from 'assets/images/s1.png';
import Sponser2 from 'assets/images/s2.png';
import Sponser3 from 'assets/images/s3.png';
import Sponser4 from 'assets/images/s4.png';
import Sponser5 from 'assets/images/s5.png';
import Sponser6 from 'assets/images/s6.png';
import Sponser7 from 'assets/images/s7.png';
import Sponser8 from 'assets/images/s8.png';
import Sponser9 from 'assets/images/s9.png';
import Sponser10 from 'assets/images/s10.png';
import Sponser11 from 'assets/images/s11.png';
import { SOCIAL_NETWORK_URLS, Fetch } from 'config/constants';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';

class PublicFooter extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            menus: []
        };
    }

    componentDidMount() {
        this.getmenu();
    }

    getmenu = async () => {
        try {
            const resp = await Fetch({ api: 'https://prismmedical.co.uk/wp-json/menus/v1/menus/footer', token: false, type: 'GET' });

            this.setState({ menus: resp.items });
        } catch (err) {
            //
        }
    }

    hadleItem = (url) => {
        window.open(url, '_blank');
    }

    render() {
        const { menus } = this.state;
        const items = [
            <div className='sponser-box' key={1}>
                <img className='sponser-img' src={Sponser1} onClick={() => this.hadleItem('https://www.bhta.com/member-details/?memberid=128787')}
                    alt='sp'/></div>,
            <div className='sponser-box' key={2}>
                <img className='sponser-img' src={Sponser2} onClick={() => this.hadleItem('https://www.tradingstandards.uk/')}
                    alt='sp'/></div>,
            <div className='sponser-box' key={3}>
                <img className='sponser-img' src={Sponser3} onClick={() => this.hadleItem('https://www.changing-places.org/')}
                    alt='sp'/>
            </div>,
            // <div className='sponser-box' key={4}>
            //     <img className='sponser-img' src={Sponser4} onClick={() => this.hadleItem('http://www.ihprojects.co.uk/index.html')}
            //         alt='sp'/></div>,
            <div className='sponser-box' key={5}><img className='sponser-img' src={Sponser5} onClick={() => this.hadleItem('https://naep.org.uk/')}
                alt='sp'/></div>,
            // <div className='sponser-box' key={6}><img className='sponser-img' src={Sponser6} onClick={() => this.hadleItem('https://namdet.org/')}
            //     alt='sp'/></div>,
            <div className='sponser-box' key={7}><img className='sponser-img' src={Sponser7} onClick={() => this.hadleItem('https://procurementforhousing.co.uk/')}
                alt='sp'/></div>,
            <div className='sponser-box' key={8}><img className='sponser-img' src={Sponser8} onClick={() => this.hadleItem('https://www.salford.ac.uk/welcome')}
                alt='sp'/></div>,
            // <div className='sponser-box' key={9}><img className='sponser-img' src={Sponser9} onClick={() => this.hadleItem('https://www.rcscard.co.uk/')}
            //     alt='sp'/></div>,
            <div className='sponser-box' key={10}><img className='sponser-img' src={Sponser10} onClick={() => this.hadleItem('https://www.constructionline.co.uk/')}
                alt='sp'/></div>,
            <div className='sponser-box' key={11}>
                <img className='sponser-img' src={Sponser11} onClick={() => this.hadleItem('https://www.ypo.co.uk/')}
                    alt='sp'/></div>
        ];

        return (
            <div className='PublicFooter'>
                <div className='PublicFooter__top'>
                    <Wrapper>
                        <div className='PublicFooter__top__content'>
                            <div className='PublicFooter__top__content__info'>
                                <div className='PublicFooter__top__content__info--logo'>
                                    <img src={Logo} alt='logo' className='PublicFooter__top__content__info--logo--img' />
                                    <div className='PublicFooter__top__content__info--logo--desc'>
                                        Prism Medical UK is a trading name of Prism UK Medical Ltd part of the Prism Healthcare Group.
                                    </div>
                                </div>
                                <div className='PublicFooter__top__content__info--addressTitle'>
                                    Registered Office:
                                </div>
                                <div className='PublicFooter__top__content__info--addresses'>
                                    <div className='PublicFooter__top__content__info--addresses--address'>
                                        Unit 4, Jubilee Business Park,<br/>
                                        Jubilee Way, Grange Moor,<br />
                                        Wakefield WF4 4TD.
                                    </div>
                                    <div className='PublicFooter__top__content__info--addresses--address'>
                                        Registered in England and<br />
                                        Wales. No. 04992349 | VAT Reg.<br />
                                        No. 315 3556 16
                                    </div>
                                </div>
                            </div>
                            <div className='PublicFooter__top__content__getInTOuch'>

                                <div className='PublicFooter__top__content__getInTOuch--title'>
                                    Get in touch
                                </div>
                                <div className='PublicFooter__top__content__getInTOuch--desc'>
                                    Call now to speak to one of<br/>
                                    our expert advisors.
                                </div>
                                <div className='PublicFooter__top__content__getInTOuch--number'>
                                    01924 840 100
                                </div>
                                <div className='PublicFooter__top__content__getInTOuch--contactUs'>
                                    <a href='https://prismmedical.co.uk/contact-us/'>Contact Us</a>
                                </div>
                                <div className='PublicFooter__top__content__getInTOuch--customer'>
                                    <a href='https://cip.prismmedical.co.uk/prismmedical/Login'>Customer Login</a>
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                    <div className='PublicFooter__top__content__getInTOuch mobileGetInTOuch'>
                        <div className='PublicFooter__top__content__getInTOuch--title'>
                            Get in touch
                        </div>
                        <div className='PublicFooter__top__content__getInTOuch--desc'>
                            Call now to speak to one of<br />
                                    our expert advisors.
                        </div>
                        <div className='PublicFooter__top__content__getInTOuch--number'>
                            01924 840 100
                        </div>
                        <div className='PublicFooter__top__content__getInTOuch--contactUs'>
                            <a href='https://prismmedical.co.uk/contact-us/'>Contact Us</a>
                        </div>
                        <div className='PublicFooter__top__content__getInTOuch--customer'>
                            <a href='https://cip.prismmedical.co.uk/prismmedical/Login'>Customer Login</a>
                        </div>
                    </div>
                </div>
                <div className='PublicFooter__center deskFooterCenter'>
                    <Wrapper>
                        <div className='PublicFooter__center__copyRight'>
                            <div className='PublicFooter__center__copyRight--title'>
                                © {new Date().getFullYear()}
                            </div>
                            <div className='PublicFooter__center__copyRight--menu'>
                                <ul className='PublicFooter__center__copyRight--menu--ul'>
                                    {menus.map((menu, i) =>
                                        <li className='PublicFooter__center__copyRight--menu--ul--li' key={i}>
                                            <a href={menu.url}>
                                                {menu.title}
                                            </a>
                                        </li>
                                    )}
                                </ul>
                            </div>
                            <div className='PublicFooter__center__copyRight--socials'>
                                <div className='PublicFooter__center__copyRight--socials--icons'>
                                    <a href={SOCIAL_NETWORK_URLS.FACEBOOK}>
                                        {FaceBook} <span>Facebook</span>
                                    </a>
                                </div>
                                <div className='PublicFooter__center__copyRight--socials--icons'>
                                    <a href={SOCIAL_NETWORK_URLS.YOUTUBE}>
                                        {Youtube}<span>Youtube</span>
                                    </a>
                                </div>
                                <div className='PublicFooter__center__copyRight--socials--icons'>
                                    <a href={SOCIAL_NETWORK_URLS.LINKEDIN}>
                                        {LinkedIn}<span>LinkedIn</span>
                                    </a>
                                </div>
                                <div className='PublicFooter__center__copyRight--socials--icons'>
                                    <a href={SOCIAL_NETWORK_URLS.TWITTER}>
                                        {Twitter}<span>Twitter</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                </div>
                <div className='PublicFooter__bottom'>
                    <Wrapper>
                        <div className='PublicFooter__bottom__sponsers'>
                            <div className='PublicFooter__bottom__sponsers--title'>
                                Prism Medical UK is proud to be associated with:
                            </div>
                            <div>
                                <div>
                                    <AliceCarousel
                                        autoPlayInterval={1300}
                                        disableButtonsControls={true}
                                        disableDotsControls={true}
                                        infinite={true}
                                        autoPlay={true}
                                        items={items}
                                        responsive={{
                                            0: {
                                                items: 2
                                            },
                                            480: {
                                                items: 2
                                            },
                                            768: {
                                                items: 4
                                            },
                                            992: {
                                                items: 5
                                            },
                                            1250: {
                                                items: 9,
                                                itemsFit: 'contain'
                                            }
                                        }} />
                                </div>
                            </div>
                            {/* <div className='PublicFooter__bottom__sponsers--contents'>
                                <div className='PublicFooter__bottom__sponsers--contents--flex'>
                                    <div className='PublicFooter__bottom__sponsers--contents--flex--items'>
                                        <img src={Sponser1} alt='sponser' />
                                    </div>
                                    <div className='PublicFooter__bottom__sponsers--contents--flex--items'>
                                        <img src={Sponser2} alt='sponser' />
                                    </div>
                                    <div className='PublicFooter__bottom__sponsers--contents--flex--items'>
                                        <img src={Sponser3} alt='sponser' />
                                    </div>
                                    <div className='PublicFooter__bottom__sponsers--contents--flex--items'>
                                        <img src={Sponser11} alt='sponser' />
                                    </div>
                                    <div className='PublicFooter__bottom__sponsers--contents--flex--items'>
                                        <img src={Sponser4} alt='sponser' />
                                    </div>
                                    <div className='PublicFooter__bottom__sponsers--contents--flex--items'>
                                        <img src={Sponser5} alt='sponser' />
                                    </div>
                                </div>
                                <div className='PublicFooter__bottom__sponsers--contents--flex'>
                                    <div className='PublicFooter__bottom__sponsers--contents--flex--items'>
                                        <img src={Sponser6} alt='sponser' />
                                    </div>
                                    <div className='PublicFooter__bottom__sponsers--contents--flex--items'>
                                        <img src={Sponser7} alt='sponser' />
                                    </div>
                                    <div className='PublicFooter__bottom__sponsers--contents--flex--items'>
                                        <img src={Sponser8} alt='sponser' />
                                    </div>
                                    <div className='PublicFooter__bottom__sponsers--contents--flex--items'>
                                        <img src={Sponser9} alt='sponser' />
                                    </div>
                                    <div className='PublicFooter__bottom__sponsers--contents--flex--items'>
                                        <img src={Sponser10} alt='sponser' />
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </Wrapper>
                </div>
                <div className='PublicFooter__center mobileFooterCenter'>
                    <Wrapper>
                        <div className='PublicFooter__center__copyRight'>
                            <div className='PublicFooter__center__copyRight--menu'>
                                <ul className='PublicFooter__center__copyRight--menu--ul'>
                                    <li className='PublicFooter__center__copyRight--menu--ul--li'>
                                        © 2021
                                    </li>
                                    {menus.map((menu, i) =>
                                        <li className='PublicFooter__center__copyRight--menu--ul--li' key={i}>
                                            <a href={menu.url}>
                                                {menu.title}
                                            </a>
                                        </li>
                                    )}
                                </ul>
                            </div>
                            <div className='PublicFooter__center__copyRight--socials'>
                                <div className='PublicFooter__center__copyRight--socials--icons'>
                                    <a href={SOCIAL_NETWORK_URLS.FACEBOOK}>
                                        {FaceBook} <span>Facebook</span>
                                    </a>
                                </div>
                                <div className='PublicFooter__center__copyRight--socials--icons'>
                                    <a href={SOCIAL_NETWORK_URLS.YOUTUBE}>
                                        {Youtube}<span>Youtube</span>
                                    </a>
                                </div>
                                <div className='PublicFooter__center__copyRight--socials--icons'>
                                    <a href={SOCIAL_NETWORK_URLS.LINKEDIN}>
                                        {LinkedIn}<span>LinkedIn</span>
                                    </a>
                                </div>
                                <div className='PublicFooter__center__copyRight--socials--icons'>
                                    <a href={SOCIAL_NETWORK_URLS.TWITTER}>
                                        {Twitter}<span>Twitter</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                </div>
            </div>
        );
    }
}

export default PublicFooter;
